module.exports = new __parcel__URL__("Design Sprint Hover.aceafcc7.svg").toString();